export { default } from './AnchorMenu';
